import I18nPhone from './I18nPhone';
import './style/i18nphone.less';

export default I18nPhone;
